<!-- Data Model Response Renderer -->
<rappider-ai-data-model-response-renderer
  *ngIf="responseType === AIGenerationType.DATA_MODEL"
  [responseData]="getResponseData()"
  [message]="message"
  [showActions]="true"
  (save)="onResponseAction($event)"
  (splitterToggleRequested)="onSplitterToggleRequested($event)">
</rappider-ai-data-model-response-renderer>

<!-- Entity Component Response Renderer -->
<rappider-ai-entity-component-response-renderer
  *ngIf="responseType === AIGenerationType.ENTITY_COMPONENT"
  [responseData]="getResponseData()"
  [message]="message"
  [showActions]="true"
  [projectModelId]="getProjectModelId()"
  [messageId]="getMessageId()"
  [componentDefinitionId]="getComponentDefinitionId()"
  [allMessages]="allMessages"
  (save)="onResponseAction($event)"
  (splitterToggleRequested)="onSplitterToggleRequested($event)"
  (revertRequested)="onRevertRequested($event)">
</rappider-ai-entity-component-response-renderer>

<!-- Message Template Response Renderer -->
<!-- <rappider-ai-message-template-response-renderer
  *ngIf="responseType === 'message-template'"
  [responseData]="getResponseData()"
  [message]="message"
  [showActions]="true"
  (save)="onResponseAction($event)">
</rappider-ai-message-template-response-renderer> -->

<!-- Endpoint Response Renderer -->
<!-- <rappider-ai-endpoint-response-renderer
  *ngIf="responseType === 'endpoint'"
  [responseData]="getResponseData()"
  [message]="message"
  [showActions]="true"
  (save)="onResponseAction($event)">
</rappider-ai-endpoint-response-renderer> -->

<!-- Component Response Renderer -->
<!-- <rappider-ai-component-response-renderer
  *ngIf="responseType === 'component'"
  [responseData]="getResponseData()"
  [message]="message"
  [showActions]="true"
  (save)="onResponseAction($event)">
</rappider-ai-component-response-renderer> -->

<!-- Page Response Renderer -->
<!-- <rappider-ai-page-response-renderer
  *ngIf="responseType === 'page'"
  [responseData]="getResponseData()"
  [message]="message"
  [showActions]="true"
  (save)="onResponseAction($event)">
</rappider-ai-page-response-renderer> -->

<!-- Theme Response Renderer -->
<!-- <rappider-ai-theme-response-renderer
  *ngIf="responseType === 'theme'"
  [responseData]="getResponseData()"
  [message]="message"
  [showActions]="true"
  (save)="onResponseAction($event)">
</rappider-ai-theme-response-renderer> -->

<!-- Workflow Response Renderer -->
<!-- <rappider-ai-workflow-response-renderer
  *ngIf="responseType === 'workflow'"
  [responseData]="getResponseData()"
  [message]="message"
  [showActions]="true"
  (save)="onResponseAction($event)">
</rappider-ai-workflow-response-renderer> -->
